const getCookie = require("../cookie/getCookie");

/**
 * @param mktoTrkField {HTMLInputElement}
 * @return {void}
 */
module.exports = function initMktoTrkFieldValue(mktoTrkField) {
    mktoTrkField.value = getCookie("_mkt_trk");
}